export default {
  namespaced: true,
  state: {
    errors: {},
  },
  getters: {
    errorFor: state => name => state.errors[name],
  },
  actions: {
    setErrors: ({ commit }, errors) => commit("setErrors", errors),
  },
  mutations: {
    setErrors: (state, errors) => {
      state.errors = {
        ...state.errors,
        ...errors,
      };
    },
  },
};
